import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { groupBy, orderBy } from 'lodash';
// services
import { SharedService } from '@shared/shared.service';
import { MessageService } from '@shell/message.service';
import { UsuarioService } from '@account/usuario.service';
import { ClienteService } from '@cliente/cliente.service';
import { AeropuertoService } from '@despacho/aeropuerto.service';
import { PedidoService } from '@despacho/pedido.service';
import { Cuenta } from '@shared/models/cliente/Cuenta';
import { AerolineaDestinoDTO } from '@shared/models/despacho/AerolineaDestinoDTO';
import { AerolineaDTO } from '@shared/models/despacho/AerolineaDTO';
import { AerolineaEncabezadoDTO } from '@shared/models/despacho/AerolineaEncabezadoDTO';
import { Aeropuerto } from '@shared/models/despacho/Aeropuerto';
import { ModalDestinosTamsComponent } from './modal-destinos-tams/modal-destinos-tams.component';

@Component({
  selector: 'app-destinos-tams-abm',
  templateUrl: './destinos-tams-abm.component.html',
  styles: [`
    .spinner-container {
      height: 400px;
      z-index: 0;
      position: relative;
    }
  `]
})
export class DestinosTamsAbmComponent implements OnInit, OnDestroy, OnChanges {

  @Input() aerolineaDTOSeleccionada: AerolineaEncabezadoDTO;
  cuentas: Cuenta[];

  cargandoDatos: boolean = false;
  cargandoCuentas: boolean = false;
  cargandoAeropuertos: boolean = false;
  guardandoDatos: boolean = false;
  change$: Subscription;
  listaDestinos: AerolineaDestinoDTO[]=[];
  listaDestinosMostrar: AerolineaDestinoDTO[]=[];
  listaDestinosOtraAeroplanta: AerolineaDestinoDTO[]=[];
  listaAeropuertos: Aeropuerto[];

  constructor(
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private modal:NgbModal,
    private pedidoService: PedidoService,
    private messageService: MessageService,
    private aeropuertoService: AeropuertoService,
    private clienteService:ClienteService,
    sharedService: SharedService
    ) {
      this.change$ = sharedService.aeroplantaSeleccionada.subscribe(()=>{
        this.cambiarDeAeroplanta();
      });
    }

  ngOnInit(): void {
    this.getAeropuertos();
  }

  cambiarDeAeroplanta() {
    this.ngOnChanges();
  }

  ngOnDestroy() {
    this.change$.unsubscribe();
  }

  ngOnChanges() {
    this.listaDestinos=[];
    this.listaDestinosMostrar=[];
    this.listaDestinosOtraAeroplanta=[];
    this.obtenerCuentas();
    this.obtenerAerolinea();
  }

  getAeropuertos() {
    this.cargandoAeropuertos=true;
    this.aeropuertoService.getAeropuertos()
      .subscribe(res => {
        this.listaAeropuertos = res;
        this.cargandoAeropuertos=false;
      }, ()=> {
        this.cargandoAeropuertos=false;
      });
  }

  obtenerNombreAeropuerto(codArpto:string) {
    const l = this.listaAeropuertos.find( a => a.codigoAeropuerto == codArpto);
    if(l) { return l.nombre } else { return null }
  }

  obtenerAerolinea() {
    this.mostrarSpinner();
    this.pedidoService.getAerolinea(this.aerolineaDTOSeleccionada.id)
      .subscribe(resp => {
        this.listaDestinos = resp.destinos;
        this.listaDestinosMostrar = this.listaDestinos.filter( d => d.codigoAeroplanta == this.getCodigoAeroplanta());
        this.listaDestinosOtraAeroplanta = this.listaDestinos.filter( d => d.codigoAeroplanta != this.getCodigoAeroplanta());
        // Agrupo por numeroVuelo o codigoAeropuerto
        const destinosAgrupados = groupBy(this.listaDestinosMostrar, d => d.numeroVuelo || d.codigoAeropuerto);
        // Ordeno cada grupo por diaDesde
        const gruposOrdenados = Object.keys(destinosAgrupados).map(key => {
          return orderBy(destinosAgrupados[key], ['diaDesde'], ['asc']);
        });
        // Convierto la matriz de grupos ordenados en una sola matriz
        this.listaDestinosMostrar = [].concat(...gruposOrdenados);
        this.ocultarSpinner();
      }, ()=> {
        this.ocultarSpinner();
      })
  }

  obtenerCuentas( ) {
    this.cuentas = [];
    this.cargandoCuentas = true;
    this.clienteService.getClientePorDocumento(this.aerolineaDTOSeleccionada.tipoDocumento, this.aerolineaDTOSeleccionada.cuit)
      .subscribe(resp => {
        this.cuentas = resp.cuentas.filter( c => c.activo == true );
        this.cargandoCuentas = false;
      }, ()=>{
        this.cargandoCuentas = false;
      });
  }

  eliminarDestino(d:AerolineaDestinoDTO) {
    this.listaDestinosMostrar = this.listaDestinosMostrar.filter( x => x != d);
  }

  mostrarSpinner() {
    this.cargandoDatos = true;
    this.spinner.show('spinnerGrafico')
  }

  ocultarSpinner() {
    this.cargandoDatos = false;
    this.spinner.hide('spinnerGrafico')
  }

  guardarCambios() {

    this.guardandoDatos = true;
    const aerolineaDTO = new AerolineaDTO;

    aerolineaDTO.id = this.aerolineaDTOSeleccionada.id;
    aerolineaDTO.cuit = this.aerolineaDTOSeleccionada.cuit;
    aerolineaDTO.razonSocial = this.aerolineaDTOSeleccionada.razonSocial;
    aerolineaDTO.codigoAerolinea = this.aerolineaDTOSeleccionada.codigoAerolinea.toUpperCase();
    aerolineaDTO.cuentaNacional = this.aerolineaDTOSeleccionada.cuentaNacional;
    aerolineaDTO.cuentaInternacional = this.aerolineaDTOSeleccionada.cuentaInternacional;
    aerolineaDTO.destinos = this.listaDestinosOtraAeroplanta.concat(this.listaDestinosMostrar);

    this.pedidoService.putAerolineas(this.aerolineaDTOSeleccionada.id, aerolineaDTO)
    .subscribe(() => {
      this.messageService.showSuccessMessage('Destino modificado con éxito.');
      this.guardandoDatos = false;
    }, () => {
      this.messageService.showErrorMessage('Hubo un error al modificar el Destino.');
      this.guardandoDatos = false;
    });
  }

  getCodigoAeroplanta(){
    return this.usuarioService.getAeroplantaActual().codigoAeroplanta;
  }

  getNombreAeroplanta(){
    return this.usuarioService.getAeroplantaActual().nombre;
  }

  agregarDestinos() {
    const modalRef = this.modal.open(ModalDestinosTamsComponent, { centered: true });
    modalRef.componentInstance.cuentas = this.cuentas;
    modalRef.componentInstance.destinos = this.listaDestinosMostrar;
    modalRef.componentInstance.destinosOtrasAeroplantas = this.listaDestinosOtraAeroplanta;
    modalRef.componentInstance.aerolineaSeleccionada = this.aerolineaDTOSeleccionada;
    modalRef.componentInstance.codAeroplanta = this.getCodigoAeroplanta();
    modalRef.componentInstance.nombreAeroplanta = this.getNombreAeroplanta();
  }

  actualizarCuenta(index: number, property: string, event: any) {
    this.listaDestinosMostrar[index][property] = event?.target?.value != '' ? event.target.value : null;
  }
}
